// extracted by mini-css-extract-plugin
export var active = "_n1-2";
export var recordingDot = "_n1-1";
export var recordingIndicator = "_n1-0";